import { render } from "./DisclosureStateEmitter.vue?vue&type=template&id=41bfe0fb"
import script from "./DisclosureStateEmitter.vue?vue&type=script&lang=js"
export * from "./DisclosureStateEmitter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__